export default __webpack_public_path__ + "undo.asset.c27dcf647f5599c97520721435771763.svg";